/**
 * Entity.ts
 * Base class for all game objects (units, buildings, projectiles).
 */

import { Faction, type WorldPosition } from '../types';

let nextEntityId = 1;

export abstract class Entity {
  readonly id: string;
  position: WorldPosition = { x: 0, y: 0 };
  faction: Faction = Faction.Neutral;
  alive = true;

  constructor(id?: string) {
    this.id = id ?? `e${nextEntityId++}`;
  }

  /** Per-frame update. delta is in seconds. */
  abstract update(delta: number): void;

  /** Remove the entity from play. */
  destroy(): void {
    // TODO: tear down sprites/listeners and mark dead.
    this.alive = false;
  }
}
